<div class="bg-primary" id="layoutDefault">
    <div id="layoutDefault_content">
        <div class="header-overland-expo-west-2023 d-flex justify-content-end align-items-center">
            <div class="header-text heavy">
                <div class="d-inline-block space">TREDDER IS A NEW</div>
                <div class="d-inline-block">KIND OF INSURANCE</div>
                <div class="d-block">RE-ENGINEERED FOR OVERLANDERS.</div>
            </div>
            <sbf-early-access-form class="d-none d-lg-block"></sbf-early-access-form>
        </div>
        <div class="d-flex justify-content-center align-items-center d-block d-lg-none mt-n10"><sbf-early-access-form></sbf-early-access-form></div>
        <sbf-coverage-table></sbf-coverage-table>
    </div>
    <div id="layoutDefault_footer">
        <div class="text-sm px-3 px-lg-10 pb-3">*Prices are based on rating plans that may vary by state. Coverage options are selected by the customer, and availability and eligibility may vary. Discount varies and is not available in all states or situations and potential savings could be different.</div>
        <div class="text-sm px-3 px-lg-10 pb-3">This site is protected by reCAPTCHA and the Google <a class="text-white" href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Privacy Policy </a>and <a class="text-white" href="https://policies.google.com/terms" target="_blank" rel="noreferrer">Terms of Service </a>apply.</div>
        <div class="text-sm px-3 px-lg-10 pb-3">{{copyrightString}}</div>
    </div>
</div>
